export function TranslationsNederlands() 
{
    return [   
        {"id":"A name field is required","value":"Een naam veld is verplicht"},   
        {"id":"Actions","value":"Acties"},
        {"id":"Access key","value":"Toegang sleutel"},
        {"id":"Access token","value":"Toegang token"},
        {"id":"Account","value":"Account"},
        {"id":"Account ID","value":"Account ID"},
        {"id":"Account URL","value":"Account URL"},
        {"id":"Actions on incoming call","value":"Acties bij een inkomend gesprek"},
        {"id":"Add a custom integration","value":"Een handmatige integratie toevoegen"},
        {"id":"Add line","value":"Regel toevoegen"}, 
        {"id":"Add variable","value":"Variabele toevoegen"}, 
        {"id":"Add new integration","value":"Integratie toevoegen"},
        {"id":"Add new script","value":"Script toevoegen"},
        {"id":"Address","value":"Adres"},  
        {"id":"API private key","value":"API prive sleutel"},
        {"id":"API public key","value":"API publieke sleutel"},
        {"id":"API key","value":"API sleutel"},
        {"id":"API secret","value":"API geheim"},
        {"id":"API token","value":"API token"},
        {"id":"API URL","value":"API URL"},
        {"id":"App ID","value":"App ID"},
        {"id":"App secret","value":"App geheim"},
        {"id":"App token","value":"App token"},
        {"id":"Application","value":"Applicatie"},
        {"id":"$Application connection token received succesfully","value":"$Application verbindingstoken is correct ontvangen"}, 
        {"id":"Application token","value":"Applicatie token"},   
        {"id":"At least one phone number field is required","value":"Tenminste één telefoonnummer veld is verplicht"},       
        {"id":"Auto-execute","value":"Automatisch uitvoeren"}, 
        {"id":"Automatic synchronization disabled","value":"Automatische synchronisatie uitgeschakeld"},
        {"id":"Automatic synchronization in","value":"Automatische synchronisatie over"},
        {"id":"Automatically synchronize every day","value":"Automatisch elke dag synchroniseren"},
        {"id":"Automatically synchronize every week","value":"Automatisch elke week synchroniseren"},
        {"id":"BACK","value":"VORIGE"},
        {"id":"Board","value":"Board"},
        {"id":"Call fields","value":"Gespreksvelden"},
        {"id":"Call notification","value":"Gesprek notificatie"},
        {"id":"Caller name","value":"Beller naam"},
        {"id":"Caller number","value":"Beller nummer"},                
        {"id":"Can be modified from computer","value":"Kan worden gewerkt vanaf computer"},
        {"id":"Cancel","value":"Annuleren"},
        {"id":"cannot be configured in the Webconfigurator because the integration is client-based","value":"kan niet worden geconfigureerd in de Webconfigurator omdat de integratie client-based is"},
        {"id":"cannot be configured in the Webconfigurator because the integration requires manual field configuration","value":"kan niet worden geconfigureerd in de Webconfigurator omdat de integratie handmatige veld configuratie vereist"},
        {"id":"CD key","value":"CD sleutel"},   
        {"id":"Check settings","value":"Instellingen controleren"},
        {"id":"Cannot have more than one name field","value":"Kan niet meerdere naamvelden selecteren"},    
        {"id":"Choose an integration template", "value": "Kies een applicatie sjabloon"},    
        {"id":"Choose how you want to link to this application's recognition","value":"Kies hoe u wilt koppelen met de herkenning van deze applicatie"},
        {"id":"Choose CRM","value":"Kies CRM"},
        {"id":"Choose file","value":"Kies bestand"},
        {"id":"City","value":"Stad"},    
        {"id":"Client call notification","value":"Client gesprek notificatie"},
        {"id":"Client ID","value":"Client ID"},
        {"id":"Client secret","value":"Client geheim"},
        {"id":"Cluster","value":"Cluster"},
        {"id":"Company Id","value":"Bedrijf Id"},
        {"id":"Configuration OK","value":"Configuratie OK"},
        {"id":"Configure","value":"Configureren"},
        {"id":"Configure incoming call","value":"Inkomend gesprek configureren"},        
        {"id":"Configure the $DatasourceName connection","value":"Configureer de $DatasourceName verbinding"}, 
        {"id":"Configure the action you want to perform","value":"Configureer de actie die u wilt uitvoeren"}, 
        {"id":"Configure the information you want the client to show when a caller is recognized from this set","value":"Configureer de informatie die de client moet laten zien wanneer een gesprek wordt herkend uit deze set"}, 
        {"id":"Configure the recognition fields","value":"Configureer de herkenningsvelden"},   
        {"id":"Configure to send an email when synchronization fails","value":"Configureer om een email te versturen wanneer de synchronisatie mislukt"},         
        {"id":"Configure your call notification","value":"Configureer uw gespreksnotificatie"},   
        {"id":"Connect","value":"Verbinden"},    
        {"id":"Country","value":"Land"},   
        {"id":"Country code","value":"Landcode"},           
        {"id":"CRM configuration","value":"CRM configuratie"},
        {"id":"Current set: <count> phone number records", "value": "Huidige set: <count> telefoonnummer records"},
        {"id":"Custom field","value":"Handmatig veld"},
        {"id":"Custom phone fields","value":"Handmatige telefoon velden"},        
        {"id":"Database","value":"Database"},
        {"id":"Database country code","value":"Database landcode"},
        {"id":"Database ID","value":"Database ID"},
        {"id":"days","value":"dagen"},
        {"id":"<days> days ago","value":"<days> dagen geleden"},
        {"id":"Ddi name","value":"Ddi naam"},
        {"id":"Ddi number","value":"Ddi nummer"},
        {"id":"Delete","value":"Verwijderen"},
        {"id":"Destination","value":"Bestemming"},    
        {"id":"Device name","value":"Toestel naam"},
        {"id":"Device number","value":"Toestel nummer"},
        {"id":"Disable","value":"Uitschakelen"},
        {"id":"Do you really want to remove this integration?","value":"Weet u zeker dat u deze integratie wil verwijderen?"},
        {"id":"Do you really want to remove this script?","value":"Weet u zeker dat u dit script wil verwijderen?"},
        {"id":"Domain","value":"Domein"},
        {"id":"Done","value":"Klaar"},
        {"id":"Edit","value":"Wijzigen"},   
        {"id":"Editing not available in web app","value":"Wijzigen niet mogelijk in de web app"},
        {"id":"Email", "value": "Email"},    
        {"id":"Enable","value":"Inschakelen"},  
        {"id":"Enter the call field values to test the script with","value":"Voer de gesprekswaardes in om het script mee te testen"},   
        {"id":"<empty line>","value":"<lege regel>"},       
        {"id":"Enter the import country code","value":"Voer de landcode van de import in"},
        {"id":"Execute script","value":"Voer script uit"},
        {"id":"Failed to retrieve secure upload link","value":"Het ophalen van de beveiligde upload link is mislukt"},
        {"id":"Failed to update the integration","value":"Het updaten van de integratie is mislukt"},
        {"id":"Failed to upload file","value":"Bestand uploaden mislukt"},
        {"id":"File upload ok","value":"Bestand uploaden ok"},
        {"id":"Filename","value":"Bestandsnaam"},
        {"id":"Finish","value":"Voltooien"},
        {"id":"Get available boards","value":"Haal beschikbare boards op"},
        {"id":"Header","value":"Header"},
        {"id":"here","value":"hier"},
        {"id":"Home","value":"Home"},
        {"id":"hours","value":"uur"},
        {"id":"<hours> hours ago","value":"<hours> uur geleden"},
        {"id":"If the integration fails to synchronize, an email will be sent to: <email>","value":"Als de synchronisatie van de integratie mislukt, dan wordt een email gestuurd naar: <email>"},  
        {"id":"Include accounts","value":"Accounts toevoegen"},  
        {"id":"Include contacts","value":"Contacten toevoegen"},  
        {"id":"Include employees","value":"Werknemers toevoegen"},  
        {"id":"Include companies","value":"Bedrijven toevoegen"},  
        {"id":"Include leads","value":"Leads toevoegen"}, 
        {"id":"Include organizations","value":"Organisaties toevoegen"},  
        {"id":"Include people","value":"Mensen toevoegen"},  
        {"id":"Include users","value":"Gebruikers toevoegen"}, 
        {"id":"Incoming call","value":"Inkomend gesprek"},   
        {"id":"InSite URL","value":"InSite URL"},           
        {"id":"Instance domain","value":"Instance domain"},           
        {"id":"Integrations","value":"Integraties"},    
        {"id":"Integrations created with the desktop configurator can only be changed with the desktop configurator from the same computer.","value":"Integraties gemaakt met de desktop configurator kunnen alleen worden bewerkt door de desktop configurator vanaf dezelfde computer"},        
        {"id":"just now","value":"zojuist"},             
        {"id":"Key","value":"Sleutel"}, 
        {"id":"Language","value":"Taal"},
        {"id":"Line","value":"Regel"}, 
        {"id":"Loading...","value":"Bezig met laden..."},
        {"id":"Location info","value":"Locatie informatie"},
        {"id":"minute","value":"minuut"},
        {"id":"minute ago","value":"minuut geleden"},
        {"id":"minutes","value":"minuten"},
        {"id":"<minutes> minutes ago","value":"<minutes> minuten geleden"},
        {"id":"My Custom Script","value":"Mijn Aangepaste Script"},
        {"id":"Name","value":"Naam"}, 
        {"id":"Next","value":"Volgende"},
        {"id":"Next synchronization could not be determined","value":"Volgende synchronisatie kan niet worden bepaald"},     
        {"id":"No","value":"Nee"},     
        {"id":"No email is currently configured","value":"Er is momenteel geen e-mail geconfigureerd"}, 
        {"id":"No file chosen","value":"Geen bestand gekozen"},         
        {"id":"No recognition has been configured","value":"Er is geen herkenning geconfigureerd"},        
        {"id":"No scripts have been configured","value":"Er zijn geen scripts geconfigureerd"},        
        {"id":"No settings are required. Click Next to continue","value":"Er zijn geen instellingen nodig. Klik Volgende om door te gaan"},
        {"id":"Not synchronized yet","value":"Nog niet gesynchoniseerd"}, 
        {"id":"OK","value":"OK"}, 
        {"id":"Only synchronize manually","value":"Alleen handmatig synchroniseren"},         
        {"id":"Open application","value":"Open applicatie"},
        {"id":"Open webpage","value":"Open webpagina"},
        {"id":"Or, if your application is not in the list","value":"Of, als uw applicatie niet in de lijst staat"},
        {"id":"Organization","value":"Organisatie"},
        {"id":"Organization ID","value":"Organisatie ID"},
        {"id":"Organization number","value":"Organisatienummer"},
        {"id":"Participant number","value":"Deelnemer nummer"},
        {"id":"Password","value":"Wachtwoord"},
        {"id":"Perform an action in application","value":"Voer een actie uit in applicatie"},
        {"id":"Phone number","value":"Telefoonnummer"},   
        {"id":"phone number records","value":"telefoonnummer records"},
        {"id":"Please download the Desktop Configurator","value":"Download de Desktop Configurator"},
        {"id":"predefined script","value":"voorgedefinieerd script"},
        {"id":"Preview","value":"Voorbeeld"},
        {"id":"Preview incoming call","value":"Voorbeeld inkomend gesprek"},
        {"id":"Profit Services URL","value":"Profit Services URL"},
        {"id":"Recognition","value":"Herkenning"},
        {"id":"Recognition fields","value":"Herkenningsvelden"},
        {"id":"Recognition from","value":"Herkenning uit"},
        {"id":"Reference","value":"Referentie"},
        {"id":"Region","value":"Regio"},
        {"id":"Remove this line","value":"Deze regel verwijderen"},        
        {"id":"Requests per minute","value":"Verzoeken per minuut"}, 
        {"id":"Retrieving secure update link","value":"Bezig met ophalen van beveiligde upload link"},          
        {"id":"Review","value":"Overzicht"},    
        {"id":"Review your integration","value":"Overzicht van uw integratie"}, 
        {"id":"FINISH","value":"VOLTOOIEN"},  
        {"id":"NEXT","value":"VOLGENDE"},          
        {"id":"Sandbox account","value":"Sandbox account"}, 
        {"id":"Security token","value":"Beveiligingstoken"}, 
        {"id":"Screenpop URL","value":"Screenpop URL"},    
        {"id":"Script name","value":"Scriptnaam"},
        {"id":"Script settings","value":"Script instellingen"},
        {"id":"Scripts","value":"Scripts"},
        {"id":"Secret","value":"Geheim"},
        {"id":"Secret key","value":"Geheime sleutel"},
        {"id":"Select how the data should be synchronized","value":"Selecteer hoe de data gesynchroniseerd moet worden"},
        {"id":"Select your FileVine login","value":"Selecteer uw FileVine login"},     
        {"id":"Serial number","value":"Serienummer"},   
        {"id":"Service URL","value":"Service URL"},    
        {"id":"Sheet","value":"Blad"},        
        {"id":"Sign out","value":"Afmelden"},
        {"id":"Signed in as","value":"Aangemeld als"},      
        {"id":"Site","value":"Site"},
        {"id":"Software key","value":"Software key"},
        {"id":"Sorry","value":"Sorry"},
        {"id":"Source info","value":"Bron informatie"},
        {"id":"Subdomain","value":"Subdomein"},
        {"id":"Synchronization info","value":"Synchronisatie informatie"},
        {"id":"Sync now","value":"Sync nu"}, 
        {"id":"System name","value":"Systeemnaam"},     
        {"id":"Tenant","value":"Tenant"},
        {"id":"Test environment","value":"Test omgeving"},
        {"id":"Test script","value":"Test script"},
        {"id":"This application uses live search and does not need synchronization","value":"Deze applicatie gebruikt live search and heeft geen synchronisatie nodig"},
        {"id":"The server will automatically execute script","value":"De server voert automatisch het script uit"},
        {"id":"This integration is disabled","value":"Deze integratie is uitgeschakeld"},
        {"id":"This recognition is disabled","value":"Deze herkenning is uitgeschakeld"},
        {"id":"This script is disabled","value":"Dit script is uitgeschakeld"},
        {"id":"Token","value":"Token"},
        {"id":"Token XML","value":"Token XML"},
        {"id":"Unavailable in the Webconfigurator","value":"Niet beschikbaar in de Webconfigurator"},
        {"id":"unknown type","value":"onbekend type"},
        {"id":"Uploading file","value":"Bezig met uploaden van bestand"},  
        {"id":"URL","value":"URL"},  
        {"id":"Use","value":"Gebruik"},
        {"id":"Use a team domain","value":"Gebruik een team domein"},
        {"id":"User","value":"Gebruiker"},
        {"id":"Username","value":"Gebruikersnaam"},
        {"id":"Waiting for OAUTH verification","value":"Bezig met wachten op OAUTH verificatie"},
        {"id":"Webpage","value":"Webpagina"},
        {"id":"Web service username","value":"Web service gebruikersnaam"},
        {"id":"Web service password","value":"Web service wachtwoord"},   
        {"id":"WebService URL","value":"WebService URL"},   
        {"id":"Welcome to the <branding_product> Webconfigurator for CRM integration","value":"Welkom bij de <branding_product> Webconfigurator voor CRM integratie"}, 
        {"id":"with caption","value":"met titel"},
        {"id":"With this tool you can manage your CRM integrations","value":"Met deze tool kunt u uw CRM integraties beheren"},  
        {"id":"Yes","value":"Ja"},                
        {"id":"Your organization","value":"Uw organisatie"}        
    ]
}